import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { SubscriptionBundlesVM } from '../../../viewModel/subscriptionBundles.viewModel';
import { footerWrapper, stepsWrapper } from './StartExclusiveBundleModal.css';
import { ExclusiveSubscriptionInfo } from './steps/ExclusiveSubscription';
import { Price } from '../../form/Price';
import { Recommendation } from './steps/Recommendation';
import { HowItWorks } from './steps/HowItWorks';

export type StartExclusiveBundleModalProps =
  SubscriptionBundlesVM['startExlusiveBundleModal'] & {
    dispatch: SubscriptionBundlesVM['dispatch'];
  };

export const StartExclusiveBundleModal: React.FC<
  StartExclusiveBundleModalProps
> = ({ isOpen, close, ...p }) => (
  <Modal
    isOpen={isOpen}
    onClose={close}
    modalClassName="w-full lg:w-[1120px] h-[100%] md:h-[800px] flex flex-col justify-between"
    disableBackdropClick={true}
    footer={<Footer stepCta={p.stepCta} />}
  >
    <div className={stepsWrapper}>
      <Step {...p} />
    </div>
  </Modal>
);

const Step = ({
  step,
  ...p
}: Pick<
  StartExclusiveBundleModalProps,
  'step' | 'control' | 'transformPrice' | 'price' | 'error' | 'dispatch'
>) => {
  switch (step) {
    case 1:
      return <ExclusiveSubscriptionInfo />;
    case 2:
      return <HowItWorks />;
    case 3:
      return <Recommendation dispatch={p.dispatch} />;
    case 4:
      return <Price {...p} />;
  }
};

const Footer: React.FC<Pick<StartExclusiveBundleModalProps, 'stepCta'>> = ({
  stepCta,
}) => (
  <div className={footerWrapper}>
    {stepCta.map(({ title, onClick, variant, submitting }) => (
      <Button
        key={title}
        color="neutral"
        onClick={onClick}
        variant={variant || 'filled'}
        disabled={submitting}
        loading={submitting}
      >
        {title}
      </Button>
    ))}
  </div>
);
